// work-around for Chromium; see #163390

export default function stripePageSections() {
    const
        selectors = [
            '.page-section:nth-child(even of .page-section-not-preceded-by-unsectioned-pods)',
            '.page-section:nth-child(odd of .page-section-preceded-by-unsectioned-pods)'
        ],
        elements = document.querySelectorAll(selectors.join(', '));
    elements.forEach(el => el.classList.add('page-section-striped'));
}
